import React, { useState, useRef } from 'react';

import { Tooltip } from '@phonepe/enigma-ui';

import { TextConstants } from '../../../constants';
import { ICopyClipboardWithTooltipProps } from './CopyClipboardWithTooltip.types';
import styles from './CopyClipboardWithTooltip.module.scss'; 

const CopyClipboardWithTooltip: React.FC<ICopyClipboardWithTooltipProps> = ({
	text,
	disabled = false,
	hoverContent = TextConstants.COPY_TO_CLIPBOARD_DEFAULT_HOVER_TEXT,
	copiedContent = TextConstants.COPY_TO_CLIPBOARD_DEFAULT_COPIED_TEXT,
	clickTooltipDuration = 2000,
	callbackHandler,
	placement = "top",
	children,
}) => {

	const [isClicked, setIsClicked] = useState<boolean>(false);
	const [isHovered, setIsHovered] = useState<boolean>(false);
	const eventRef = useRef<React.MouseEvent | null>(null);

	const handleHoverChange = (isOpen: boolean) => {
		setIsHovered(isOpen);
		setIsClicked(false);
	};

	const handleClickChange = () => {
		setIsClicked(true);
		if (eventRef.current) {
			eventRef.current.stopPropagation();
		}
		setTimeout(() => {
			setIsClicked(false);
			setIsHovered(false);
		}, clickTooltipDuration);
	};

	const copyToClipboard = (event: React.MouseEvent) => {
		if (callbackHandler) {
			callbackHandler();
		}
		navigator.clipboard.writeText(text);
		eventRef.current = event;
		handleClickChange();
	};

	const childProps = {
		handleClick: copyToClipboard,
		disabled,
	}

	return (
		<Tooltip
			title={isClicked ? copiedContent : hoverContent}
			trigger="hover"
			onOpenChange={handleHoverChange}
			open={isHovered}
			overlayClassName={styles.tooltip}
			placement={placement}
		>
			<div className={styles.copyIconContainer}>
				{children?.(childProps)}
			</div>
		</Tooltip>
	);
};

export default CopyClipboardWithTooltip;
